export const GAME_MODE = {
    CLASSIC: 'classic',
    COUNTRY: 'country',
};
